import React from 'react';

const fallbackBodyRootRef: React.MutableRefObject<HTMLDivElement | null> = {
  current: null,
};

export type ModalContentContextType = {
  scrollToTop(): void;
  bodyRootRef: React.MutableRefObject<HTMLDivElement | null>;
  isBusy: boolean;
  /** When set (modal stack from `ModalProvider`), consumers (e.g. `Form`) can drive busy state for external footers or actions. */
  setIsBusy?(value: boolean): void;
};

const ModalContentContext = React.createContext<ModalContentContextType | null>(
  {
    scrollToTop() {
      console.warn('ModalContentContext provider not found.');
    },
    bodyRootRef: fallbackBodyRootRef,
    isBusy: false,
  },
);

export default ModalContentContext;
